module.exports = __webpack_public_path__ + "static/media/ImpactHero.221fb483.png";